<p-confirmDialog [style]="{width: '420px'}"></p-confirmDialog>

<div class="card">

  <!-- Cabeçalho -->
  <div class="flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
    <app-header
      titulo="Monitoramento de Processos"
      descricao="Acompanhe o status de execução de cada fluxo de integração em tempo real.">
    </app-header>
    <p-button
      icon="pi pi-refresh"
      label="Atualizar"
      (onClick)="carregarProcessos()"
      [loading]="loading">
    </p-button>
  </div>

  <!-- Cards de resumo: skeleton -->
  <div *ngIf="loading" class="grid mb-3">
    <div class="col-12 md:col-6 lg:col-3" *ngFor="let i of [1,2,3,4]">
      <div class="border-1 surface-border border-round p-3 flex align-items-center gap-3">
        <p-skeleton shape="circle" size="2.5rem"></p-skeleton>
        <div style="flex:1">
          <p-skeleton width="40%" height="1.6rem" styleClass="mb-1"></p-skeleton>
          <p-skeleton width="70%" height="0.7rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <!-- Cards de resumo -->
  <div *ngIf="!loading && !erro" class="grid mb-3">
    <div class="col-12 md:col-6 lg:col-3">
      <div class="border-1 surface-border border-round p-3 flex align-items-center gap-3">
        <div class="flex align-items-center justify-content-center border-round"
          style="width:2.5rem;height:2.5rem;background:var(--blue-100)">
          <i class="pi pi-desktop text-blue-500"></i>
        </div>
        <div>
          <div class="text-900 font-bold text-2xl">{{ processos.length }}</div>
          <div class="text-500 text-sm font-medium">Total de Processos</div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="border-1 surface-border border-round p-3 flex align-items-center gap-3">
        <div class="flex align-items-center justify-content-center border-round"
          style="width:2.5rem;height:2.5rem;background:var(--green-100)">
          <i class="pi pi-check-circle text-green-500"></i>
        </div>
        <div>
          <div class="text-green-600 font-bold text-2xl">{{ totalAtivos }}</div>
          <div class="text-500 text-sm font-medium">Ativos</div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="border-1 border-round p-3 flex align-items-center gap-3"
        [class.border-red-200]="totalFalhas > 0"
        [ngStyle]="totalFalhas > 0 ? {'background':'#fff8f8'} : {}">
        <div class="flex align-items-center justify-content-center border-round"
          style="width:2.5rem;height:2.5rem;background:var(--red-100)">
          <i class="pi pi-clock text-red-500"></i>
        </div>
        <div>
          <div class="font-bold text-2xl"
            [class.text-red-600]="totalFalhas > 0"
            [class.text-900]="totalFalhas === 0">{{ totalFalhas }}</div>
          <div class="text-500 text-sm font-medium">Falhas Totais</div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="border-1 surface-border border-round p-3 flex align-items-center gap-3">
        <div class="flex align-items-center justify-content-center border-round"
          style="width:2.5rem;height:2.5rem;background:var(--orange-100)">
          <i class="pi pi-chart-line text-orange-500"></i>
        </div>
        <div>
          <div class="text-orange-600 font-bold text-2xl">{{ taxaMediaSucesso | number:'1.0-0' }}%</div>
          <div class="text-500 text-sm font-medium">Taxa Média Sucesso</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div *ngIf="!loading && !erro" class="flex align-items-center gap-2 mb-3 flex-wrap">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        placeholder="Buscar processo..."
        [(ngModel)]="termoBusca"
        class="p-inputtext-sm" />
    </span>
    <p-button
      label="Todos"
      [styleClass]="filtroTipo === 'todos' ? 'p-button-sm' : 'p-button-sm p-button-outlined'"
      (onClick)="filtroTipo = 'todos'">
    </p-button>
    <p-button
      icon="pi pi-arrow-down"
      label="Recebimento"
      [styleClass]="filtroTipo === 'recebimento' ? 'p-button-sm p-button-info' : 'p-button-sm p-button-info p-button-outlined'"
      (onClick)="filtroTipo = 'recebimento'">
    </p-button>
    <p-button
      icon="pi pi-arrow-up"
      label="Envio"
      [styleClass]="filtroTipo === 'envio' ? 'p-button-sm p-button-warning' : 'p-button-sm p-button-warning p-button-outlined'"
      (onClick)="filtroTipo = 'envio'">
    </p-button>
  </div>

  <!-- Estado de erro -->
  <div *ngIf="!loading && erro"
    class="flex flex-column align-items-center justify-content-center p-5 surface-50 border-round border-1 surface-border">
    <i class="pi pi-exclamation-triangle text-4xl text-orange-400 mb-3"></i>
    <h3 class="text-900 mt-0 mb-1">Não foi possível carregar os processos</h3>
    <p class="text-500 mb-3">Verifique a conexão com o serviço de visualização ou tente novamente.</p>
    <p-button
      label="Tentar Novamente"
      icon="pi pi-refresh"
      styleClass="p-button-outlined"
      (onClick)="carregarProcessos()">
    </p-button>
  </div>

  <!-- Tabela -->
  <p-table
    *ngIf="!loading && !erro"
    [value]="processosFiltrados"
    styleClass="p-datatable-sm"
    [tableStyle]="{'min-width': '56rem'}"
    [paginator]="true"
    [rows]="10"
    [alwaysShowPaginator]="false"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Exibindo {first}–{last} de {totalRecords} processos">

    <ng-template pTemplate="header">
      <tr>
        <th>Processo</th>
        <th style="width: 130px">Tipo</th>
        <th style="width: 80px" class="text-right">Total</th>
        <th style="width: 80px" class="text-right">Sucesso</th>
        <th style="width: 80px" class="text-right">Falhas</th>
        <th style="width: 170px">Taxa de Sucesso</th>
        <th style="width: 100px">Status</th>
        <th style="width: 130px" class="text-right"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-proc>
      <tr>
        <td>
          <div class="flex align-items-center gap-2">
            <p-button
              icon="pi pi-play"
              pTooltip="Executar processo"
              tooltipPosition="top"
              styleClass="p-button-sm p-button-success p-button-rounded p-button-text"
              [loading]="executandoId === proc.id"
              [disabled]="!proc.ativo"
              (onClick)="confirmarExecucao(proc)">
            </p-button>
            <div [class.opacity-60]="!proc.ativo">
              <span class="font-semibold text-900">{{ proc.nome }}</span>
              <div class="text-500 text-sm mt-1">{{ proc.descricao }}</div>
            </div>
          </div>
        </td>
        <td [class.opacity-60]="!proc.ativo">
          <p-tag
            [value]="getTipoLabel(proc)"
            [severity]="getTipoSeverity(proc)"
            [icon]="getTipoIcon(proc)">
          </p-tag>
        </td>
        <td class="text-right font-semibold text-900" [class.opacity-60]="!proc.ativo">
          {{ getTotalRegistros(proc) | number }}
        </td>
        <td class="text-right font-semibold text-green-600" [class.opacity-60]="!proc.ativo">
          {{ getTotalSucesso(proc) | number }}
        </td>
        <td class="text-right font-semibold"
          [class.text-red-600]="getTotalFalhas(proc) > 0"
          [class.text-900]="getTotalFalhas(proc) === 0" [class.opacity-60]="!proc.ativo">
          {{ getTotalFalhas(proc) | number }}
        </td>
        <td [class.opacity-60]="!proc.ativo">
          <div class="flex align-items-center gap-2" *ngIf="getTotalRegistros(proc) > 0; else semRegistros">
            <div class="border-round overflow-hidden"
              style="width:80px; height:7px; background:#e5e7eb; flex-shrink:0">
              <div class="h-full border-round"
                [style.width.%]="getPercentualSucesso(proc)"
                [style.background]="getProgressBarColor(proc)">
              </div>
            </div>
            <span class="text-sm font-bold" [style.color]="getProgressBarColor(proc)">
              {{ getPercentualSucesso(proc) | number:'1.0-0' }}%
            </span>
          </div>
          <ng-template #semRegistros>
            <span class="text-500 text-sm">—</span>
          </ng-template>
        </td>
        <td>
          <p-inputSwitch
            [(ngModel)]="proc.ativo"
            (onChange)="alterarStatus(proc)">
          </p-inputSwitch>
        </td>
        <td class="text-right">
          <p-button
            icon="pi pi-list"
            label="Ver Registros"
            styleClass="p-button-sm p-button-outlined"
            (onClick)="verRegistros(proc)">
          </p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">
          <div class="flex flex-column align-items-center p-5 text-500">
            <i class="pi pi-inbox text-4xl mb-3"></i>
            <span>Nenhum processo encontrado.</span>
          </div>
        </td>
      </tr>
    </ng-template>

  </p-table>

</div>
